import {
  getColumnIndex,
} from '../../../../components/gsheet';


export default function updateData(
  rawDataCollection, seqType, rows, header) {

  const hasRawSequences = rawDataCollection.rawSequences.length > 0;

  if (seqType === 'ClinicalList') {
    if (hasRawSequences) {
      return updateClinicalData(
        rawDataCollection, rows, header
      );
    } else {
      return updateClinicalStartData(
        rawDataCollection, rows, header
      );
    }
  } else {
    return updateLabData(
      rawDataCollection, rows, header
    );
  }
}


function updateClinicalStartData(
  rawDataCollection, rows, header) {
  rows.shift();
  const {references} = rawDataCollection;
  const reference = references[0];
  const rawSequences = [];
  for (const row of rows) {
    const seq = {
      refName: reference.refName,
      isolateName: row[getColumnIndex(header, 'Isolate Name')],
      isolateType: 'Clinical',
      gene: row[getColumnIndex(header, 'Gene')],
      mutations: row[getColumnIndex(header, 'Mutations')],
    };

    let isCompletedMutationList = row[getColumnIndex(
      header, 'isCompleteMutationList')];

    if (!isCompletedMutationList || isCompletedMutationList === '') {
      isCompletedMutationList = 'NO';
    }

    isCompletedMutationList = isCompletedMutationList.toUpperCase();
    if (isCompletedMutationList === 'YES') {
      seq.seqType = 'IncompleteSequence';
    } else {
      seq.seqType = 'PartialMutationList';
    }

    rawSequences.push(seq);
  }
  rawDataCollection.rawSequences = rawSequences;

  return rawDataCollection;
}

function updateClinicalData(
  rawDataCollection, rows, header) {
  rows.shift();
  const {references} = rawDataCollection;
  const reference = references[0];
  const rawSequences = [];
  for (const row of rows) {
    const seq = {
      refName: reference.refName,
      ptAlias: row[getColumnIndex(header, 'PtAlias')],
      isolateName: row[getColumnIndex(header, 'Isolate Name')],
      isolateDate: row[getColumnIndex(header, 'Isolate Date')],
      isolateDateMatch: '=',
      isolateType: 'Clinical',
      host: 'HUMAN',
      parent: 'HXB2',
      source: row[getColumnIndex(header, 'Source')],
      species: row[getColumnIndex(header, 'Species')],
      region: row[getColumnIndex(header, 'Region')],
      authorSubtype: row[getColumnIndex(header, 'Author subtype')],
      gene: row[getColumnIndex(header, 'Gene')],
      mutations: row[getColumnIndex(header, 'Mutations')],
    };

    const authorSubtype = row[getColumnIndex(header, 'Author subtype')].toUpperCase();
    if (authorSubtype === 'HIV2A') {
      seq.parent = 'ROD';
    } else if (authorSubtype === 'HIV2B') {
      seq.parent = 'EHO';
    } else if (authorSubtype.startsWith('HIV2')) {
      seq.parent = 'ROD';
    } else {
      seq.parent = 'CONB';
    }

    const isCompletedMutationList = row[getColumnIndex(
      header, 'isCompleteMutationList')].toUpperCase();
    if (isCompletedMutationList === 'YES') {
      seq.seqType = 'IncompleteSequence';
    } else {
      seq.seqType = 'PartialMutationList';
    }

    rawSequences.push(seq);
  }
  rawDataCollection.rawSequences = rawSequences;

  return rawDataCollection;

}

function updateLabData(
  rawDataCollection, rows, header) {
  rows.shift();
  const rawSequences = [];
  const {references} = rawDataCollection;
  const reference = references[0];
  for (const row of rows) {
    let _parent = row[getColumnIndex(header, 'Parent Strain')];
    let _species = 'HIV1';
    if (_parent === 'ROD') {
      _species = 'HIV2';
    } else if (_parent === 'EHO') {
      _species = 'HIV2';
    }
    const seq = {
      refName: reference.refName,
      existingPatientId: 11630,
      ptAlias: 'LabStrain',
      isolateName: row[getColumnIndex(header, 'Isolate Name')],
      isolateDate: (new Date()).toISOString().slice(0, 10),
      isolateDateMatch: '=',
      isolateType: 'Lab',
      species: _species,
      host: 'HUMAN',
      seqType: 'PartialMutationList',
      parent: _parent,
      labSdm: row[getColumnIndex(header, 'isSDM')],
      labPassage: row[getColumnIndex(header, 'isUsingPassage')],
      gene: row[getColumnIndex(header, 'Gene')],
      mutations: row[getColumnIndex(header, 'Mutations')],
    };
    rawSequences.push(seq);
  }
  rawDataCollection.rawSequences = rawSequences;
  rawDataCollection.sequenceType = 'incomplete';
  rawDataCollection.seqType = 'LabList';

  return rawDataCollection;
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/gtable_mut/update-data.js